import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html } from '../../common'

$(init)

async function init () {
  let $page = $('#pending-orders-page')
  if ($page.length == 0) {
    return
  }
  try {
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let orders = (await get_json(`/premium/get-my-pending-orders`)).data
    $page.find('.loading-indicator').addClass('d-none')
    if (orders.length == 0) {
      $page.find('.orders-empty').removeClass('d-none')
    } else {
      let $orders = $page.find('.orders')
      $orders.removeClass('d-none')
      $orders.html('')
      for (let order of orders) {
        if (order.plan || (order.custom_price && order.custom_label)) {
          $orders.append(eval_html_template('#order-template', order))
        }
      }
    }
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
